import { css } from "@emotion/react"
import { Typography } from "matsuri-ui"
import React from "react"
import { theme } from "@/theme"

interface LargeIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string
    icon: React.ReactNode
    color?: string
}

const LargeIconButton = ({
    text,
    icon,
    color = "inherit",
    ...props
}: LargeIconButtonProps) => {
    const buttonStyle = css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        aspect-ratio: 167/164;
        padding: 16px;
        color: ${props.disabled ? theme.palette.gray[400] : "inherit"};
        background-color: ${props.disabled ? theme.palette.gray[200] : "#fff"};
        border: 2px solid ${theme.palette.gray[300]};
        border-radius: 10px;
        box-shadow: ${
            props.disabled
                ? "none"
                : "0px 4px 6px -1px rgba(0, 0, 0, 0.1),0px 2px 4px -1px rgba(0, 0, 0, 0.1)"
        };
        &:active {
            background-color: ${theme.palette.gray[200]};
        }
    `

    return (
        <button css={buttonStyle} {...props}>
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 48px;
                `}
            >
                <Typography variant="h4" bolder>
                    {text}
                </Typography>
            </div>
            {icon}
        </button>
    )
}

export default LargeIconButton
